class SystemNotificationPayload {
  constructor(systemNotificationPayloadData = {}) {
    this.title = systemNotificationPayloadData.title || "";
    this.subtitle = systemNotificationPayloadData.subtitle || "";
    this.description = systemNotificationPayloadData.description || "";
  }
}

export default SystemNotificationPayload;
